import { useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { TextField, ListItem, ListItemText, Divider } from "@mui/material";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useGetAccountNumbers } from "./hooks/useGetAccountNumber";
import { AfbAccountNumbersProps } from "./types";

export const AfbAccountNumbers = ({ open, onClose, changeAlert, changeLoader }: AfbAccountNumbersProps) => {
    const { zPos, data, error, search, loading: loadingRequest, disabled, onHandleChange, onHandleGetAccounts } = useGetAccountNumbers(open, changeAlert);

    const half = Math.ceil(data.length / 2);
    const firstColumn = data.slice(0, half);
    const secondColumn = data.slice(half);

    const copy = (data) => {
        navigator.clipboard.writeText(data);
    };

    useEffect(() => {
        changeLoader(loadingRequest);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingRequest]);


    return (
        <Dialog onClose={() => onClose("account")} open={open} style={{ display: zPos !== 45 ? "none" : null, maxHeight: "500px" }}>
            <DialogTitle>
                <Typography variant='h2'>Solicitar Números de Cuenta</Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant='paragraph' color='primary'>Indique la cantidad de cuentas.</Typography>
                <FlexGrid container style={{paddingTop: 15, display: 'block'}}>
                    <FlexGrid item>
                        <TextField
                            value={search} onChange={onHandleChange.bind(this)} InputProps={{inputProps: { min: 1, max: 10 }}} label="N°" type={"number"} size="small"  error={error} helperText={error ? "La cantidad de cuentas, deber ser entre 1 y 10" : ''}>
                        </TextField>
                    </FlexGrid>

                    { data.length > 0 &&          
                        <FlexGrid item fullWidth>
                            <Divider sx={{my: 2, "&::before, &::after": {borderColor: "primary.light"}}}>- - -</Divider>
                            <Typography variant='paragraph'>Cuentas emitidas:</Typography>

                            <FlexGrid container item fullWidth spacing={2}>
                            {[firstColumn, secondColumn].map((column, index) => (
                                 <FlexGrid key={`column-${index}`} item fullWidth>
                                    {column.map((item, index) => {
                                        return <ListItem style={{fontStyle: "oblique"}} key={index}><FileCopyIcon titleAccess={`Copiar`} onClick={copy.bind(this, item.account_number)} cursor={"pointer"} sx={{mr: 2}} color='primary' /><ListItemText primary={item.account_number} /></ListItem>
                                    })}
                                </FlexGrid>
                            ))}
                        </FlexGrid>          
                        </FlexGrid>          
                    } 
                </FlexGrid>
            </DialogContent>

            <DialogActions sx={{marginTop: "0px !important"}}>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }} spacing={2}>
                    <FlexGrid item>
                        <Button onClick={() => onClose("account")} buttonType="secondary" size="normal">{data.length > 0 ? "Cerrar" : "Cancelar"}</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onHandleGetAccounts.bind(this)} disabled={disabled} size="normal" >Solicitar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};

export default AfbAccountNumbers;
